/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { Field, reduxForm, Form, change } from 'redux-form';


import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import moment from 'moment';
import classNames from 'classnames';
import renderCheckBoxGroup from '../../../helpers/RenderCheckBoxGroup';
import { Grid } from 'material-ui';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  contentRightCol: {
    flex: '1 0 auto',
  },
  cardContentLeft: {
    width: '45%',
  },
  cardContentRight: {
    width: '45%'
  },
  generalCardContent: {
    paddingBottom: '4px',
  },
  tierGridRow: {
    paddingBottom: '8px',
  },
  tierGridContainer: {
    paddingTop: '8px',
    textAlign: 'left',
  },
  valueFormattingLeft: {
    width: 300,
    textAlign: 'left',
    fontSize: '.9rem',
    padding: '5px 0 15px 15%'
  },
  valueFormattingRight: {
    width: 300,
    textAlign: 'left',
    fontSize: '.9rem',
    padding: '5px 0 5px 15%'
  },
  '@media only screen and (max-width: 1000px)': {
    valueContainer: {
      flexWrap: 'wrap',
    },
    card: {
      display: 'block'
    },
    cardContentLeft: {
      width: '90%'
    },
    cardContentRight: {
      width: '90%',
      marginLeft: '5%'
    },
    valueFormattingLeft: {
      padding: '5px 0 15px 0 !important'
    },
    labelField: {
      paddingLeft: 0
    },
    valueFormattingRight: {
      padding: '5px 0 15px 0'
    }
  },
  messageStyle: {
    paddingLeft: '15px',
    paddingTop: '10px'
  },
  paperStyle: {
    width: '85%',
    height: '70%',
    display: 'inline-block',
    marginTop: '5vh'
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
    textAlign: 'left'
  },
  textField1: {
    width: 350,
    textAlign: 'left'
  },
  topLabel: {
    marginTop: '40px'
  },
  labelField: {
    width: 300,
    textAlign: 'left',
    marginLeft: '12%',
    paddingRight: '50px',
    paddingTop: '15px',
    borderBottom: '1px solid #888',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  '@media screen and (min-width: 600px)': {
    cardWidth: {
      paddingLeft: '0 !important'
    },
  },
  '@media screen and (max-width: 1000px)': {
    labelField: {
      width: '100%',
      marginLeft: 0
    },
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '1%',
    textAlign: 'left',
    paddingLeft: '5%'
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  },
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  reportingLabel1: {
    color: '#ADADAD',
    textAlign: 'left',
    marginLeft: '-65%',
    fontSize: '9pt'
  },
  reportingLabel: {
    color: '#ADADAD',
    textAlign: 'left',
    marginLeft: '-70%',
    fontSize: '9pt'
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  labelStyle : {
    color: 'rgba(0, 0, 0, 0.54)'
  }
});

const buildTierRateGrid = (customerBillingReportInfo) => {
  const billingTierList = [];


  customerBillingReportInfo.forEach((billingReport) => {
    const billingTierNames = {
      'Full Vehicle History ACI': 'Full History',
      'Risk Plus Score': 'Risk Plus'
    };

    if (Object.prototype.hasOwnProperty.call(billingReport, 'reportTypeName')
        && billingReport.reportTypeName in billingTierNames
        && billingReport.name.split('/').length === 7) {

      const billingParameters = billingReport.name.split('/');
      const reportTierObject = {
        reportName: billingTierNames[billingReport.reportTypeName],
        tierCost: billingReport.value
      };
      const currentTierTerm = `${billingParameters[5]} - ${billingParameters[6]}`;
      const tierRateIndex = billingTierList.findIndex((item) => {
        if (item.tierTerm === currentTierTerm) return item;
      });

      if (tierRateIndex > -1) {
        billingTierList[tierRateIndex].tierReport.push(reportTierObject);
      } else {
        billingTierList.push({
          tierTerm: currentTierTerm,
          tierReport: [reportTierObject]
        });
      }
    }
  });

  const buildReportTierGrid = [
    <Grid container item xs={12}>
      <Grid item xs={4}>
        Volume Per Month
      </Grid>
      <Grid item xs={4}>
        Full History Rate
      </Grid>
      <Grid item xs={4}>
        Score
      </Grid>
    </Grid>
  ];
  
  buildReportTierGrid.push(billingTierList.map(( item ) =>
      <Grid container item xs={12}>
        <Grid item xs={4}>
          {item.tierTerm}
        </Grid>
        {item.tierReport.map(( tierItem, index ) =>
          <Grid item xs={4}>
            ${tierItem.tierCost}
          </Grid>
        )}
      </Grid>
    ));

    return buildReportTierGrid;
}

const ViewBillingRates = (props) => {

    const { classes, contactName, customerBillingInfo, customerBillingReportInfo, customerBillingRateInfo, contractRates, availableReports } = props;
    let customerBillingReportData = [];
    if (customerBillingRateInfo && customerBillingRateInfo.data && customerBillingRateInfo.data.getBillingRateInformation) {
      customerBillingReportData = [...customerBillingReportData, ...JSON.parse(customerBillingRateInfo.data.getBillingRateInformation)];
    }

    const billingRateInfo = [];
    const [billNoHits, setbillNoHits] = useState('No');
    const [billNoHistory, setbillNoHistory] = useState('No');
    const [billInvalidVINS, setbillInvalidVINS] = useState('No');
    const billingRules = ['ACI billing rule 2', 'ACI billing rule 3'];

    useEffect(() => {
      if (contractRates && (contractRates.billNoHits || contractRates.billNoHits === 'Yes')) setbillNoHits('Yes');
      if (contractRates && (contractRates.billNoHistory || contractRates.billNoHistory === 'Yes')) setbillNoHistory('Yes');
      if (contractRates && (contractRates.billInvalidVINS || contractRates.billInvalidVINS === 'Yes')) setbillInvalidVINS('Yes');
    });

    let flatRateAmount = 0;
    let overage = 0;
    if (customerBillingReportData.find(v => v.name.split('/').pop() === 'flat_fee')) {
      flatRateAmount = customerBillingReportData.find(v => v.name.split('/').pop() === 'flat_fee').value;
    }

    if (customerBillingReportData.find(v => v.name.split('/').pop() === 'overage')) {
      overage = customerBillingReportData.find(v => v.name.split('/').pop() === 'overage').value;
    } 
    customerBillingReportData.forEach((val) => {
      if (val.name) {
        billingRateInfo.push({ name: val.name.split('/').pop(), value: val.value });
      }
    });

    let gracePeriod = '';
    let billingPlan = 'Customer Billing Plan';

    const startDate = moment(customerBillingInfo.validFrom).format('MM/DD/YYYY');
    const endDate = moment(customerBillingInfo.validTo).format('MM/DD/YYYY');
    const descArr = customerBillingInfo.description.split(';');

    descArr.forEach((desc) => {
      if (desc.includes('rule')) {
        if (/ACA/.exec(desc)) {
          const num = /ACA/.exec(desc).index;
          billingPlan = desc.substr(num, desc.length - num);
        } else if (/ACI/.exec(desc)) {
          const num = /ACI/.exec(desc).index;
          billingPlan = desc.substr(num, desc.length - num);
        }
      }
    });

    const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];

    let billingReportList = [];

    if (billingRules.includes(billingPlan)) {
      const gracePeriodRaw = contractRates.gracePeriod ? contractRates.gracePeriod : '0';
      gracePeriod = `${parseInt(gracePeriodRaw.trim(), 10) * 24} hours`;

      billingReportList = availableReports.map((availableReport) => {
        const billingNames = {
          'Risk Predictor Score': 'Risk Predicator',
          'Full Vehicle History ACI': 'Full History',
          'Risk Plus Score': 'Risk Plus'
        };

        let reportName = availableReport.label;

        if (reportName in billingNames) {
          reportName = billingNames[reportName];
        }

        return (
          <div
            style={{ padding: '2% 0' }}
            key={availableReport.label}
          >
            <Chip
              icon={<DoneIcon />}
              label={
                <div
                  style={{ minWidth: '8em' }}
                >
                  <div>{reportName}</div>
                  <div>$0.00</div>
                </div>
              }
              style={{ padding: '8% 0' }}
            />
          </div>
        );
      })
    } else {
      billingReportList = customerBillingReportInfo.map((billingReport) => {
        let reportAmount = '0.0';
        if (customerBillingReportData.find(v => v.name === billingReport.name && v.name !== 'gracePeriod')) {
          reportAmount = customerBillingReportData.find(v => v.name === billingReport.name && v.name !== 'gracePeriod').value;
        }
        const billingNames = {
          'Risk Predictor Score': 'Risk Predicator',
          'Full Vehicle History ACI': 'Full History',
          'Risk Plus Score': 'Risk Plus'
        };

        if (billingRateInfo.find(val => val.name === 'gracePeriod')) {
          const gracePeriodRaw = billingRateInfo.find(val => val.name === 'gracePeriod').value;
          if (parseInt(gracePeriodRaw.replace('d', ''), 10) === 1) {
            gracePeriod = '1 day';
          } else if (gracePeriodRaw.includes('d')) {
            gracePeriod = gracePeriodRaw.replace('d', ' days');
          } else {
            gracePeriod = `${gracePeriodRaw.trim()} days`;
          }
        }
      
        if (Object.prototype.hasOwnProperty.call(billingReport, 'reportTypeName')) {
          let reportName = billingReport.reportTypeName;
          if (reportName in billingNames) {
            reportName = billingNames[reportName];
          }
          return (
              <div
                style={{ padding: '2% 0' }}
                key={reportName}
                >
                  <Chip
                  icon={<DoneIcon />}
                  label={
                    <div
                      style={{ minWidth: '8em' }}
                      >
                        <div>{reportName}</div>
                        <div>${reportAmount} ea</div>
                    </div>
                  }
                  style={{ padding: '8% 0' }}
                  />
              </div>
            );
        }
        return '';
      });
    }

    const reportTierGrid = buildTierRateGrid(customerBillingReportInfo);

    return (
      <Form key="ViewBillingRatesForm" onSubmit={() => {}}>
        <Card className={classes.card} xs={12} sm={6} md={6} lg={6}>
          <CardContent className={classNames(classes.cardContentLeft, classes.generalCardContent)}>
            <div className={classNames(classes.topLabel, classes.labelField)}>Contact Name</div>
            <div className={classes.valueFormattingLeft}>{contactName}</div>
            { (billingRules.includes(billingPlan)) &&
              (
              <React.Fragment>
                <div className={classNames(classes.labelField)} style={{ paddingTop: 0 }}>Monthly Invoice Min</div>
                <div className={classes.valueFormattingLeft}>{`$${flatRateAmount ? flatRateAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}`}</div>
              </React.Fragment>
              )
            }
            {['ACI billing rule 3'].includes(billingPlan) &&
              (
              <React.Fragment>
                <div className={classNames(classes.labelField)} style={{ paddingTop: 0 }}>Request Limit</div>
                <div className={classes.valueFormattingLeft}>{`${contractRates.requestLimit ? contractRates.requestLimit.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}`}</div>
              </React.Fragment>
              )
            }
            <div className={classes.labelField}>Available Reports</div>
            <div
              className="billing-report-list"
            >
              {billingReportList || <p>There are not any reports found</p>}
            </div>

          </CardContent>

          <CardContent className={classNames(classes.contentRightCol, classes.cardWidth, classes.cardContentRight, classes.generalCardContent)}>
            <div className={classNames(classes.topLabel, classes.labelField)}>Billing Plan</div>
            <div className={classes.valueFormattingRight}>{billingPlan}</div>
            {!billingRules.includes(billingPlan) &&
              <div style={{ paddingTop: 0 }}>
                <div className={classNames(classes.labelField)}>Grace Period</div>
                <div className={classes.valueFormattingRight}>{gracePeriod}</div>
              </div>
            }
            {['ACI billing rule 3'].includes(billingPlan) &&
              (
              <span>
                <div className={classNames(classes.labelField)}>Overage Rate</div>
                <div className={classes.valueFormattingLeft}>{`$${overage ? parseFloat(overage).toFixed(2) : 0}`}</div>                            
              </span>
              )
            }
            <div className={classNames(classes.labelField)}>Start Date</div>
            <div className={classes.valueFormattingRight}>{startDate}</div>
            <div className={classNames(classes.labelField)}>End Date</div>
            <div className={classes.valueFormattingRight}>{endDate}</div>
            <Field
              name="billInvalidVINs"
              checked={billInvalidVINS}
              component={renderCheckBoxGroup}
              options={optionsList}
              className={classNames('smaller-font', classes.radioGroup)}
              label="Bill Invalid VINs?"
              handleCheckChange={this.handleCheckChange}
            />
            <Field
              name="billNoHits"
              checked={billNoHits}
              component={renderCheckBoxGroup}
              options={optionsList}
              className={classNames('smaller-font', classes.radioGroup)}
              label="Bill No Hits?"
              handleCheckChange={this.handleCheckChange}
            />
            <Field
              name="billNoHistory"
              checked={billNoHistory}
              component={renderCheckBoxGroup}
              options={optionsList}
              className={classNames('smaller-font', classes.radioGroup)}
              label="Bill No History?"
              handleCheckChange={this.handleCheckChange}
            />
          </CardContent>

          <CardContent style={{ padding: '0 0 0 8%', width: '55%' }}>
            <div 
              className={classNames(classes.topLabel, classes.labelField)}
              style={{ marginTop: '0', paddingTop: '0', marginLeft: '0' }}
            >
              Billing Tier Rate
            </div>
              <Grid className={classes.tierGridContainer} container spacing={8}>
                {reportTierGrid}
              </Grid>
          </CardContent>
        </Card>
      </Form>
    );
}

ViewBillingRates.propTypes = {
  classes: PropTypes.shape().isRequired,
};

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'ViewBillingRatesForm',
  enableReinitialize: true
})(ViewBillingRates));

const ConnectedViewBillingRates = connect()(ReduxForm);


export default ConnectedViewBillingRates;


// WEBPACK FOOTER //
// ./src/components/Customer/BillingRate/ViewBillingRates.js